import { lazy, type JSX } from "react";
import {
  LayoutDashboard,
  Settings,
  Users,
  FileText,
  Database,
  Package,
  ShoppingCart,
  BarChart3,
  Shield,
  Key,
  Home,
  ShieldCheck,
  MessageCircle,
  //ArrowLeftRight,
  Landmark,
  CreditCard,
  MessageSquare,
  UserCog,
  //UserX,
  AlertTriangle,
  FileSignature,
  Container,
  Receipt
} from "lucide-react";
import PropiedadesPage from "../pages/parametrizacion/PropiedadesPage";
import ValidacionIdentidadPage from "../pages/parametrizacion/ValidacionIdentidadPage";
import Mensajeria from "../pages/parametrizacion/Mensajeria";
import TransaccionesPage from "../pages/parametrizacion/TransaccionesPage";
import UsuariosPageNew from "../pages/usuarios/UsuariosPageNew";
import PropiedadesPageNew from "../pages/propiedades/PropiedadesPageNew";
import ValidacionIdentidadPageNew from "../pages/validacionIdentidad/ValidacionIdentidadPageNew";
import TransaccionesPageNew from "../pages/transacciones/TransaccionesPageNew";
import AdminsPage from "../pages/administradores/AdminsPage";
import ReportedUsersPage from "../pages/reportados/ReportedUsersPage";
import AceptacionesPage from "../pages/aceptaciones/AceptacionesPage";
import MantenedoresPage from "../pages/mantenedores/MantenedoresPage";
import MensajeriaPage from "../pages/mensajeria/mensajeriaPage";
import FacturacionPage from "../pages/facturacion/FacturacionPage";

// Lazy loading de páginas
const DashboardPage = lazy(() => import("../pages/dashboard/DashboardPage"));
const GeneralPage = lazy(() => import("../pages/parametrizacion/GeneralPage"));
const UsuariosPage = lazy(() => import("../pages/parametrizacion/UsuariosPage"));
const RolesPage = lazy(() => import("../pages/parametrizacion/permisos/RolesPage"));
const AccesosPage = lazy(() => import("../pages/parametrizacion/permisos/AccesosPage"));
const ProductosPage = lazy(() => import("../pages/inventario/ProductosPage"));

export interface RouteConfig {
  id: string;
  path: string;
  label: string;
  icon?: React.ComponentType<{ className?: string }>;
  component?: React.LazyExoticComponent<() => JSX.Element> | (() => JSX.Element);
  children?: RouteConfig[];
  // Metadata adicional
  meta?: {
    requiresAuth?: boolean;
    roles?: string[];
    showInMenu?: boolean;
  };
}

/**
 * Configuración centralizada de rutas
 * Estructura jerárquica que se usa tanto para:
 * - Renderizar las rutas de React Router
 * - Generar el menú del Sidebar automáticamente
 */
export const routesConfig: RouteConfig[] = [
  {
    id: "dashboard",
    path: "/dashboard",
    label: "Dashboard",
    icon: LayoutDashboard,
    component: DashboardPage,
    meta: {
      requiresAuth: true,
      showInMenu: true,
    },
  },
  {
    id: "mensajeria",
    path: "/mensajeria",
    label: "Mensajería",
    icon: MessageSquare,
    component: Mensajeria,
    meta: {
      requiresAuth: true,
      showInMenu: true,
    },
  },
  /*  Nueva opcion para mensajeria */
  {
    id: "mensajeriav2",
    path: "/mensajeriav2",
    label: "Mensajería v2",
    icon: MessageCircle,
    component: MensajeriaPage,
    meta: {
      requiresAuth: true,
      showInMenu: false,
    },
  },
  /*  */
  {
    id: "usuariosPage",
    path: "/usuariosPage",
    label: "Usuarios",
    icon: Users,
    component: UsuariosPageNew,
    meta: {
      requiresAuth: true,
      showInMenu: true,
    },
  },
  {
    id: "propiedadesPage",
    path: "/propiedadesPage",
    label: "Propiedades",
    icon: Home,
    component: PropiedadesPageNew,
    meta: {
      requiresAuth: true,
      showInMenu: true,
    },
  },
  {
    id: "validacionPage",
    path: "/validacionPage",
    label: "Validación de Identidad",
    icon: Shield,
    component: ValidacionIdentidadPageNew,
    meta: {
      requiresAuth: true,
      showInMenu: true,
    },
  },
  {
    id: "reportedPage",
    path: "/reportedPage",
    label: "Denunciados",
    icon: AlertTriangle,
    component: ReportedUsersPage,
    meta: {
      requiresAuth: true,
      showInMenu: true,
    },
  },
  {
    id: "transaccionesPage",
    path: "/transaccionesPage",
    label: "Transacciones",
    icon: CreditCard,
    component: TransaccionesPageNew,
    meta: {
      requiresAuth: true,
      showInMenu: true,
    },
  },
  {
    id: "aceptacionesPage",
    path: "/aceptacionesPage",
    label: "Aceptaciones",
    icon: FileSignature,
    component: AceptacionesPage,
    meta: {
      requiresAuth: true,
      showInMenu: true,
    },
  },
  {
    id: "mantenedoresPage",
    path: "/mantenedoresPage",
    label: "Mantenedores",
    icon: Container,
    component: MantenedoresPage,
    meta: {
      requiresAuth: true,
      showInMenu: true,
    },
  },
  {
    id: "adminPage",
    path: "/adminPage",
    label: "Administradores",
    icon: UserCog,
    component: AdminsPage,
    meta: {
      requiresAuth: true,
      showInMenu: true,
    },
  },
  {
    id: "facturacionJom",
    path: "/facturacion",
    label: "Facturacion",
    icon: Receipt,
    component: FacturacionPage,
    meta: {
      requiresAuth: true,
      showInMenu: true,
    },
  },
  {
    id: "parametrizacion",
    path: "/parametrizacion",
    label: "Administración",
    icon: Settings,
    meta: {
      requiresAuth: true,
      showInMenu: false,
    },
    children: [
      {
        id: "param-general",
        path: "/parametrizacion/general",
        label: "General",
        icon: Database,
        component: GeneralPage,
        meta: {
          requiresAuth: true,
          showInMenu: false,
        },
      },
      {
        id: "param-usuarios",
        path: "/parametrizacion/usuarios",
        label: "Usuarios",
        icon: Users,
        component: UsuariosPage,
        meta: {
          requiresAuth: true,
          showInMenu: true,
        },
      },
      {
        id: "param-propiedades",
        path: "/parametrizacion/propiedades",
        label: "Propiedades",
        icon: Home,
        component: PropiedadesPage,
        meta: {
          requiresAuth: true,
          showInMenu: true,
        },
      },
      {
        id: "param-validacion",
        path: "/parametrizacion/validacion",
        label: "Validación de identidad",
        icon: ShieldCheck,
        component: ValidacionIdentidadPage,
        meta: {
          requiresAuth: true,
          showInMenu: true,
        },
      },
      {
        id: "param-mensajeria",
        path: "/parametrizacion/mensajeria",
        label: "Mensajería",
        icon: MessageCircle,
        component: Mensajeria,
        meta: {
          requiresAuth: true,
          showInMenu: true,
        },
      },
      {
        id: "param-transacciones",
        path: "/parametrizacion/transacciones",
        label: "Transacciones ACH",
        icon: Landmark,
        component: TransaccionesPage,
        meta: {
          requiresAuth: true,
          showInMenu: true,
        },
      },
      {
        id: "param-permisos",
        path: "/parametrizacion/permisos",
        label: "Permisos",
        icon: FileText,
        meta: {
          requiresAuth: true,
          showInMenu: false,
        },
        children: [
          {
            id: "permisos-roles",
            path: "/parametrizacion/permisos/roles",
            label: "Roles",
            icon: Shield,
            component: RolesPage,
            meta: {
              requiresAuth: true,
              showInMenu: true,
            },
          },
          {
            id: "permisos-accesos",
            path: "/parametrizacion/permisos/accesos",
            label: "Accesos",
            icon: Key,
            component: AccesosPage,
            meta: {
              requiresAuth: true,
              showInMenu: true,
            },
          },
        ],
      },
    ],
  },
  {
    id: "inventario",
    path: "/inventario",
    label: "Inventario",
    icon: Package,
    meta: {
      requiresAuth: true,
      showInMenu: false,
    },
    children: [
      {
        id: "inventario-productos",
        path: "/inventario/productos",
        label: "Productos",
        icon: Package,
        component: ProductosPage,
        meta: {
          requiresAuth: true,
          showInMenu: true,
        },
      },
      {
        id: "inventario-categorias",
        path: "/inventario/categorias",
        label: "Categorías",
        icon: FileText,
        component: () => (
          <div className="p-8">
            <h1 className="text-2xl font-bold">Categorías</h1>
            <p className="text-muted-foreground mt-2">
              Gestión de categorías de productos
            </p>
          </div>
        ),
        meta: {
          requiresAuth: true,
          showInMenu: true,
        },
      },
      {
        id: "inventario-almacenes",
        path: "/inventario/almacenes",
        label: "Almacenes",
        icon: Database,
        component: () => (
          <div className="p-8">
            <h1 className="text-2xl font-bold">Almacenes</h1>
            <p className="text-muted-foreground mt-2">
              Gestión de almacenes
            </p>
          </div>
        ),
        meta: {
          requiresAuth: true,
          showInMenu: true,
        },
      },
    ],
  },
  {
    id: "ventas",
    path: "/ventas",
    label: "Ventas",
    icon: ShoppingCart,
    meta: {
      requiresAuth: true,
      showInMenu: false,
    },
    children: [
      {
        id: "ventas-pedidos",
        path: "/ventas/pedidos",
        label: "Pedidos",
        icon: ShoppingCart,
        component: () => (
          <div className="p-8">
            <h1 className="text-2xl font-bold">Pedidos</h1>
            <p className="text-muted-foreground mt-2">
              Gestión de pedidos de venta
            </p>
          </div>
        ),
        meta: {
          requiresAuth: true,
          showInMenu: true,
        },
      },
      {
        id: "ventas-clientes",
        path: "/ventas/clientes",
        label: "Clientes",
        icon: Users,
        component: () => (
          <div className="p-8">
            <h1 className="text-2xl font-bold">Clientes</h1>
            <p className="text-muted-foreground mt-2">
              Gestión de clientes
            </p>
          </div>
        ),
        meta: {
          requiresAuth: true,
          showInMenu: true,
        },
      },
    ],
  },
  {
    id: "reportes",
    path: "/reportes",
    label: "Reportes",
    icon: BarChart3,
    meta: {
      requiresAuth: true,
      showInMenu: false,
    },
    children: [
      {
        id: "reportes-ventas",
        path: "/reportes/ventas",
        label: "Ventas",
        icon: BarChart3,
        component: () => (
          <div className="p-8">
            <h1 className="text-2xl font-bold">Reportes de Ventas</h1>
            <p className="text-muted-foreground mt-2">
              Análisis y reportes de ventas
            </p>
          </div>
        ),
        meta: {
          requiresAuth: true,
          showInMenu: true,
        },
      },
      {
        id: "reportes-inventario",
        path: "/reportes/inventario",
        label: "Inventario",
        icon: Package,
        component: () => (
          <div className="p-8">
            <h1 className="text-2xl font-bold">Reportes de Inventario</h1>
            <p className="text-muted-foreground mt-2">
              Análisis y reportes de inventario
            </p>
          </div>
        ),
        meta: {
          requiresAuth: true,
          showInMenu: true,
        },
      },
    ],
  },
];

/**
 * Función helper para aplanar la estructura de rutas
 * Útil para obtener todas las rutas en un array plano
 */
export const flattenRoutes = (routes: RouteConfig[]): RouteConfig[] => {
  const flat: RouteConfig[] = [];

  const flatten = (items: RouteConfig[]) => {
    items.forEach((item) => {
      if (item.component) {
        flat.push(item);
      }
      if (item.children) {
        flatten(item.children);
      }
    });
  };

  flatten(routes);
  return flat;
};

/**
 * Función para obtener solo las rutas que deben mostrarse en el menú
 * Filtra recursivamente todas las rutas y submenús
 */
export const getMenuRoutes = (routes: RouteConfig[]): RouteConfig[] => {
  return routes
    .filter((route) => route.meta?.showInMenu !== false)
    .map((route) => {
      // Si tiene children, también filtrarlos recursivamente
      if (route.children) {
        return {
          ...route,
          children: getMenuRoutes(route.children),
        };
      }
      return route;
    });
};

/**
 * Función para buscar una ruta por su path
 */
export const findRouteByPath = (
  routes: RouteConfig[],
  path: string
): RouteConfig | undefined => {
  for (const route of routes) {
    if (route.path === path) {
      return route;
    }
    if (route.children) {
      const found = findRouteByPath(route.children, path);
      if (found) return found;
    }
  }
  return undefined;
};

/**
 * Función para verificar si una ruta requiere autenticación
 */
export const requiresAuth = (route: RouteConfig): boolean => {
  return route.meta?.requiresAuth !== false; // Por defecto true
};

/**
 * Función para verificar si un usuario tiene acceso a una ruta basado en roles
 */
export const hasAccess = (route: RouteConfig, userRole?: string): boolean => {
  // Si no hay roles definidos, todos tienen acceso
  if (!route.meta?.roles || route.meta.roles.length === 0) {
    return true;
  }

  // Verificar si el rol del usuario está en la lista de roles permitidos
  return userRole ? route.meta.roles.includes(userRole) : false;
};

/**
 * Función para filtrar rutas basadas en el rol del usuario
 */
export const filterRoutesByRole = (
  routes: RouteConfig[],
  userRole?: string
): RouteConfig[] => {
  return routes
    .filter((route) => hasAccess(route, userRole))
    .map((route) => {
      if (route.children) {
        return {
          ...route,
          children: filterRoutesByRole(route.children, userRole),
        };
      }
      return route;
    });
};
